import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import './AppShell.styl';

type Props = {
  /** Optional icon rail (the platform console); without it the sidebar is the only navigation column. */
  rail?: ReactNode;
  sidebar: ReactNode;
  topbar: ReactNode;
  content: ReactNode;
  /** Below 1100 px the sidebar is an off-canvas drawer; this opens it. */
  sidebarOpen?: boolean;
  onSidebarClose?: () => void;
};

/** Operational shell filling the viewport: (optional rail) + sidebar + topbar + scrollable content. */
export function AppShell({ rail, sidebar, topbar, content, sidebarOpen = false, onSidebarClose }: Props) {
  const { t } = useTranslation();
  const classes = ['t-shell'];
  if (sidebarOpen) classes.push('t-shell--drawer-open');
  if (!rail) classes.push('t-shell--no-rail');
  return (
    <div className={classes.join(' ')}>
      {rail ? <div className="t-shell__rail">{rail}</div> : null}
      <div className="t-shell__sidebar">{sidebar}</div>
      {sidebarOpen ? <button type="button" className="t-shell__backdrop" aria-label={t('shell.closeMenu')} onClick={onSidebarClose} /> : null}
      <div className="t-shell__main">
        <div className="t-shell__topbar">{topbar}</div>
        <div className="t-shell__content">{content}</div>
      </div>
    </div>
  );
}
